import React from "react";
import { Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Grid,
  MenuItem,
  Select,
  TextField,
  InputAdornment
} from "@mui/material";
import { getDateFormatset } from "utils";
import { COLORS, InputFieldWrapper, TYPOGRAPHY_COMMON_STYLES } from "components";
import { HelperTextWrapper } from "./HelperTextWrapper";
import { RenderFieldProps } from "./types";
import { FormValues } from "../types";
import { DATE_FIELDS, SELECT_FIELDS } from "../consts";

export const RenderField = ({
  control,
  column,
  countries,
  utilityTypes,
}: RenderFieldProps) => (
  <Grid item xs={8} sm={6} key={column.header}>
    <Controller
      name={column.accessorKey as keyof FormValues}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <InputFieldWrapper
          label={column.accessorKey === "renewableEnergy" ? column.header : `${column.header} *`}
        >
          {SELECT_FIELDS.includes(column.accessorKey) ? (
            column.accessorKey === "utilityTypeName" ? (
              <Select
                {...field}
                disabled
                sx={{ width: "100%", height: "36px" }}
                value={field.value || ""}
                error={!!error}
              >
                {utilityTypes.map((type) => (
                  <MenuItem
                    key={type.id}
                    value={type.name}
                    sx={{
                      fontWeight: TYPOGRAPHY_COMMON_STYLES.fontWeightSemiBold,
                      fontSize: 14,
                      lineHeight: "18px",
                      color: "#90959E",
                      "&:hover": { backgroundColor: "#F6F8FA", borderRadius: 5, color: COLORS.Romance },
                      "&.Mui-selected": { backgroundColor: "#F6F8FA", borderRadius: 5, color: COLORS.Romance },
                    }}
                  >
                    {type.name}
                  </MenuItem>
                ))}
              </Select>
            ) : column.accessorKey === "country" ? (
              <Select
                {...field}
                disabled
                sx={{ width: "100%", height: "36px" }}
                value={field.value || ""}
                error={!!error}
              >
                {countries.map((country: string) => (
                  <MenuItem
                    key={country}
                    value={country}
                    sx={{
                      fontWeight: TYPOGRAPHY_COMMON_STYLES.fontWeightSemiBold,
                      fontSize: 14,
                      lineHeight: "18px",
                      color: "#90959E",
                      "&:hover": { backgroundColor: "#F6F8FA", borderRadius: 5, color: COLORS.Romance },
                      "&.Mui-selected": { backgroundColor: "#F6F8FA", borderRadius: 5, color: COLORS.Romance },
                    }}
                  >
                    {country}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <TextField
                {...field}
                size="small"
                disabled
                fullWidth
                variant="outlined"
                error={!!error}
                helperText={HelperTextWrapper(error?.message || '')}
                sx={{ marginLeft: 0 }}
              />
            )
          ) : DATE_FIELDS.includes(column.accessorKey) ? (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                {...field}
                slotProps={{
                  textField: {
                    size: "small",
                    sx: { width: "100%" },
                    error: !!error,
                    helperText: HelperTextWrapper(error?.message || '')
                  },
                }}
                format={getDateFormatset()}
              />
            </LocalizationProvider>
          ) : (
            <TextField
              {...field}
              size="small"
              error={!!error}
              helperText={HelperTextWrapper(error?.message || '')}
              fullWidth
              variant="outlined"
              sx={{ marginLeft: 0 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <span style={{ color: COLORS.Romance }}>%</span>
                  </InputAdornment>
                ),
              }}
            />
          )}
        </InputFieldWrapper>
      )}
    />
  </Grid>
);
